module.exports = __webpack_public_path__ + "img/icon-validation.6d3785fe.svg";